import { Template } from "@xapp/ovai-lib";
import { Credentials } from "auth";
import { Handler, Organization } from "generated/graphql";
import { ClientApp, ClientIntent } from "models";
import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";
import { State } from "redux/state";

export type UpdateTemplate = "UPDATE_TEMPLATE";
export const UPDATE_TEMPLATE: UpdateTemplate = "UPDATE_TEMPLATE";
export type UpdateTemplateEnd = "UPDATE_TEMPLATE_END";
export const UPDATE_TEMPLATE_END: UpdateTemplateEnd = "UPDATE_TEMPLATE_END";

export interface UpdateTemplateAction extends Action {
    payload: {
        credentials: Credentials;
        organization: Organization;
        template: Template;
        selectOnSuccess?: boolean;
    };
    type: UpdateTemplate;
}

export function updateTemplate(
    template: Template,
    selectOnSuccess?: boolean
): ThunkAction<void, State, undefined, UpdateTemplateAction> {
    return (dispatch: Dispatch<UpdateTemplateAction>, getState) => {
        const credentials = getState().auth.credentials;
        const organization = getState().org.currentOrg;

        dispatch(updateTemplateWithCredentials(credentials, template, organization, selectOnSuccess));
    };
}

function updateTemplateWithCredentials(
    credentials: Credentials,
    template: Template,
    organization: Organization,
    selectOnSuccess: boolean
): UpdateTemplateAction {
    return {
        payload: {
            credentials,
            organization,
            selectOnSuccess,
            template
        },
        type: UPDATE_TEMPLATE
    };
}

export interface UpdateTemplateEndAction extends Action {
    payload: {
        app?: ClientApp;
        intents?: (ClientIntent | Handler)[];
        error?: Error;
    };
    type: UpdateTemplateEnd;
}

export function updateTemplateEnd(
    error: Error,
    app?: ClientApp,
    intents?: (ClientIntent | Handler)[]
): UpdateTemplateEndAction {
    return {
        payload: {
            app,
            error,
            intents
        },
        type: UPDATE_TEMPLATE_END
    };
}
